<template>
<div>
    <div class="dashboard-panel break-word">
      <div class="row">
        <div class="col-12">
          <h3><icon type="users" class="mr-1" />  {{ $t('Users') }}</h3>
          <hr class="panel-hr" />
        </div>
        <div class="col-6">
          <canvas :id="userChartId" class="mb-5" height="200" width="400"></canvas>
          <span class="lighter">{{ $t('dashboard.numberOfViewers') }}</span><br/>
          <b>{{ viewers.length }}</b><br/><br/>

          <mini-popup
              v-if="viewers && viewers.length"
              ref="miniPopup1"
              min-width="250px"
              min-height="100px"
              :show-icon="true"
              :icon-type="'info-circle'"
              :icon-class="'ml-1 lighter'"
          >
            <div class="clickable" slot="linkContent">{{ $t('VIEWERS') }} <icon type="angle-right" /></div>
            <div slot="popupContent">
              <div v-for="user in viewers" :key="user.id" class="small-font">
                <div>
                  {{ user.name }}
                </div>
              </div>
            </div>
          </mini-popup>
        </div>
        <div class="col-6">
          <canvas :id="userChartId2" class="mb-5" height="200" width="400"></canvas>

          <span class="lighter">{{ $t('dashboard.numberOfEditors') }}</span><br/>
          <b>{{ editors.length }}</b><br/><br/>
          <mini-popup
              v-if="editors && editors.length"
              ref="miniPopup1"
            min-width="250px"
            min-height="100px"
            :show-icon="true"
            :icon-type="'info-circle'"
            :icon-class="'ml-1 lighter'"
          >
            <div class="clickable" slot="linkContent">{{ $t('EDITORS') }} <icon type="angle-right" /></div>
            <div slot="popupContent">
              <div v-for="user in editors" :key="user.id + 'viewer'" class="small-font">
                <div>
                  {{ user.name }}
                </div>
              </div>
            </div>
          </mini-popup>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import Icon from "@/components/Icon.vue";
import {initChart} from "@/components/organizationDashboard/ChartHelper";
import MiniPopup from "@/components/exportProfiles/MiniPopup.vue";
export default {
  name: "UserPanel",
  components: {Icon, MiniPopup},
  props: {
    organizationId: {type: String, required:true},
    autoLoad: {type: Boolean, default: false},
    editorLimit: {type: Number, default: 200},
    viewerLimit: {type: Number, default: 1000},
    orgUsers: {type: Array, default: () => []},
  },
  data() {
    return {
      users: [],
      viewers: [],
      editors: [],
      userChartId: 'userChart_' + Math.random().toString(36).substring(7),
      userChartId2: 'userChart2_' + Math.random().toString(36).substring(7),
    };
  },
  beforeMount() {
    if (this.autoLoad) {
      this.loadOrganizationUsers();
    }
  },
  methods: {
    initChart,
    getEditorTeams(teams) {
      return teams ? !!teams.filter(item => {
        return ['editor', 'admin'].includes(item.members[0].relation.role);
      }).length : false;
    },
    async loadOrganizationUsers() {
      await this.$store.dispatch('loadUsers', {
        add: {
          filter: {[this.$route.params.id]: 'homeOrganizationId eq ' + this.$route.params.id},
        }
      }).then(async users => {
        if (users) {
          for (let i = 0; i < users.length; i++) {
            const {id} = users[i];
            const teams = await this.$store.dispatch('clientLoadUserTeams', {
              id: id
            });
            users[i].teams = teams ? teams.filter(item => {
              return item.organizationId === this.$route.params.id
            }) : [];
            users[i].isEditor = this.getEditorTeams(users[i].teams);
            const filtered = this.orgUsers.filter(item => {
              return item.userId === id;
            });
            users[i].organizationRole = filtered && filtered.length ? filtered[0].role : 'none';
            if (['editor', 'admin'].includes(users[i].organizationRole)) {
              users[i].isEditor = true;
            }
          }
          this.users = users;
          if (this.users.length) {
            this.editors = this.users.filter(item => {
              return item.isEditor
            });
            this.viewers = this.users.filter(item => {
              return !item.isEditor
            });
            this.userChart = this.initChart(this, this.userChart,
                {
                  chartId: this.userChartId,
                  limit: this.viewerLimit,
                  total: this.viewers.length,
                  labels: [this.$t('dashboard.viewerLicenses'), this.$t('dashboard.used')]
                });
            this.userChart2 = this.initChart(this, this.userChart2,
                {
                  chartId: this.userChartId2,
                  limit: this.editorLimit,
                  total: this.editors.length,
                  labels: [this.$t('dashboard.editorLicenses'), this.$t('dashboard.used')]
                });
          }
        }
      });
    },
  }
}
</script>